export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBkPSJNMi40MTU3OSAyMy45MjYyTDAuMDgyNDg5IDIxLjU5MjlMOS40MTU3OSAxMi4yNTk2TDAuMDgyNDg5IDIuOTI2MTZMMi40MTU3OSAwLjU5Mjg2NUwxMS43NDkyIDkuOTI2MTZMMjEuMDgyNSAwLjU5Mjg2NUwyMy40MTU4IDIuOTI2MTZMMTQuMDgyNSAxMi4yNTk2TDIzLjQxNTggMjEuNTkyOUwyMS4wODI1IDIzLjkyNjJMMTEuNzQ5MiAxNC41OTI5TDIuNDE1NzkgMjMuOTI2MloiIGZpbGw9IiMyMTE3NTIiLz4KICA8L3N2Zz4KICA="


//////////////////
// WEBPACK FOOTER
// ./images/close.svg
// module id = 152
// module chunks = 0